import 'focus-within-polyfill';

import './global/jquery-migrate';
import './common/select-option-plugin';
import PageManager from './page-manager';
import quickSearch from './global/quick-search';
import currencySelector from './global/currency-selector';
import mobileMenuToggle from './global/mobile-menu-toggle';
import menu from './global/menu';
import foundation from './global/foundation';
import quickView from './global/quick-view';
import cartPreview from './global/cart-preview';
import privacyCookieNotification from './global/cookieNotification';
import adminBar from './global/adminBar';
import addToCartHandler from './global/addtocart-handler';
import wishlist from './global/wishlist';
import newsletter from './global/newsletter';
import carousel from './common/carousel';
import loadingProgressBar from './global/loading-progress-bar';
import svgInjector from './global/svg-injector';

import './custom/custom';

import OrderListingB2b from './account/orders';
import OrderDetailB2b from './account/order-detail';

export default class Global extends PageManager {
    onReady() {
        const {
            channelId, cartId, productId, categoryId, secureBaseUrl, maintenanceModeSettings, adminBarLanguage, showAdminBar,
        } = this.context;
        cartPreview(secureBaseUrl, cartId);
        quickSearch();
        currencySelector(cartId);
        foundation($(document));
        quickView(this.context);
        carousel(this.context);
        menu();
        mobileMenuToggle();
        privacyCookieNotification();
        if (showAdminBar) {
            adminBar(secureBaseUrl, channelId, maintenanceModeSettings, JSON.parse(adminBarLanguage), productId, categoryId);
        }
        loadingProgressBar();
        svgInjector();
        addToCartHandler(this.context);
        wishlist(this.context);
        newsletter();
        this.mobileQuickSearchToggle();



    	/**GPI ADDED BUNDLE B2B SCRIPT**/
    	// only need to change the version number to update the version
        const url = 'https://cdn.bundleb2b.net/bundleb2b.3.2.0.js';
        const el = document.createElement('script');
        el.setAttribute('src', url);
        document.querySelector('body').append(el);
        window.b3themeConfig = window.b3themeConfig || {};
        window.b3themeConfig.useStyles = {
            'tpa.entryButton' : {
                display: 'none !important'
            },
            'dashboard.head.info.container' : {
                width: '100%'
            },
            'dashboard.head.container': {
                width: '100% !important'
            },
            'dashboard.head.info.left': {
                fontWeight: '700',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
        }
        window.b3themeConfig.useJavaScript = {
            login: {
                callback() {
                    $('.body').show();
                },
            },
            tpa: {
                beforeMount(instance) {

                    if(window.location.href.indexOf('&show_tpa') > 0) {
                        $('.swticher-item.b2b-create').addClass('--active');
                        $('.desc-item.b2b-create').show();
                        $('.customer_create_form').addClass('b2b-create-form');
                        $('.field_AddressLine1 .form-label').html('Billing Address Line 1<small>REQUIRED</small>') ;
                        $('.field_AddressLine2 .form-label').html('Billing Address Line 2') ;
                        $('.field_FirstName .form-label').html('Contact First Name<small>REQUIRED</small>');
                        $('.field_LastName .form-label').html('Contact Last Name<small>REQUIRED</small>');
                        $('.field_Phone .form-label').html('Contact Phone Number<small>REQUIRED</small>');
                        $('.field_EmailAddress .form-label').html('Contact Email<small>REQUIRED</small>');
                        $('.field_ConfirmPassword .form-label').html('Reenter Password<small>REQUIRED</small>');
                        $('.field_City .form-label').html('City<small>REQUIRED</small>');
                        $('.field_State .form-label').html('State<small>REQUIRED</small>');
                        $('.field_Zip .form-label').html('Zip Code<small>REQUIRED</small>');

                        instance.setState({
                            customFields: [
                                {
                                    render() {
                                        var taxExemptHtml = '';
                                        var taxtVar = 'is_tax_exempt';
                                        var taxlabel = 'My Church/Organization is tax exempt';
                                        var taxDesc = 'You will be emailed at the Contact Email provided above with instructions on completing your tax exemption. We do not need a shipping address.';
                                        taxExemptHtml += `<div class="form-field is_tax_exempt-wrapper">`;
                                            taxExemptHtml += `<input id="${taxtVar}" type="checkbox" value="${taxlabel}" name="${taxtVar}" class="form-checkbox">`;
                                            taxExemptHtml += `<label class="form-label" for="${taxtVar}">${taxlabel}</label>`;
                                            taxExemptHtml += `<span class="form-field-desc">${taxDesc}</span>`
                                        taxExemptHtml += `</div>`

                                        return taxExemptHtml
                                    }
                                }
                            ]
                        })
                    }else {
                        $('.swticher-item.normal-create').addClass('--active');
                        $('.desc-item.normal-create').show()
                        $('.customer_create_form').addClass('normal-create-form');
                    }

                },
                mounted(instance) {
                    if(window.location.href.indexOf('&show_tpa') > 0) {
                        $('#tpa-phone-filed .form-label').html('Church/Organization Phone Number<small>REQUIRED</small>');
                        $('.form-field .form-label').each(function(){
                            //console.log($.trim($(this).text()))
                            if($.trim($(this).text()) == 'Tax Exempt Category' || $.trim($(this).text()) == 'Company Tax Exempt Code' || $.trim($(this).text()) == 'Tax Exemption Expiration') {
                                $(this).parent().addClass('field_taxExemptItems');
                                $(this).attr('disabled', 'disabled')
                            }

                        })
                        // $('.form-field[data-type="Country"]').addClass('test123')
                        $('.form-field[data-type="CompanyName"]').prependTo($('.b2b-create-form .form-row--custom'))
                        $('.form-field[data-type="Country"]').insertAfter($('.form-field[data-type="CompanyName"]'))
                        $('.form-field[data-type="Zip"]').insertAfter($('.form-field[data-type="Country"]'))
                        $('.form-field[data-type="City"]').insertAfter($('.form-field[data-type="Zip"]'))
                        $('.form-field[data-type="State"]').insertAfter($('.form-field[data-type="City"]'))
                        $('.form-field[data-type="AddressLine1"]').insertAfter($('.form-field[data-type="State"]'))
                        $('.form-field[data-type="AddressLine2"]').insertAfter($('.form-field[data-type="AddressLine1"]'))
                        $('.form-field[data-type="Phone"]').insertAfter($('.form-field[data-type="AddressLine2"]'))
                        $('#tpa-phone-filed').insertAfter($('.form-field[data-type="EmailAddress"]'))
                        $('#tpa-email-filed').insertAfter($('#tpa-phone-filed'));
                        $('.form-field[data-type="Password"]').insertAfter($('.form-field[data-type="LastName"]'))
                        $('.form-field[data-type="ConfirmPassword"]').insertAfter($('.form-field[data-type="Password"]'))
                    }else {
                        
                        $('.form-field[data-type="AddressLine1"]').insertAfter($('.form-field[data-type="State"]'))
                        $('.form-field[data-type="AddressLine2"]').insertAfter($('.form-field[data-type="AddressLine1"]'))
                    }
                    $('.customer_create_form').css({
                        "opacity": "1"
                    })
                }
            },
            quickorderpad: {
                overwrite: true,
                callback: instance => {
                    $('#pc-quickorderpad-entry').remove();
                }
            },
            orders: {
                mounted() {
                    OrderListingB2b();
                }
            },
            orderdetail: {
                mounted() {
                    OrderDetailB2b();
                }
            },
        };
        window.b3themeConfig.useText = {
            'tpa.button': 'New Account',
            'tpa.form.submit.button': 'create account',
            'tpa.form.company.name.label': 'Church/Organization Name',
            'tpa.form.company.email.label': 'Church/Organization Email'

        };
        window.b3themeConfig.useContainers = {
            'dashboard.endMasquerade.container': '.end_masquerade .em-marker',
            //'quickOrderPad.button.container': '.salerep-infobox .container'
        }

        const pathname = window.location.pathname;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (pathname == "/account.php" && urlParams.has('action') && urlParams.get('action') == "download_item") {
            $('.body').show();
        }
    }
    mobileQuickSearchToggle() {
        $('.mobileSearch-toggle').click(function() {
            $('#quickSearch').toggleClass('mobile-active')
        })
    }
}
